import { Feature } from "ol";
import { Point } from "ol/geom";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Select } from "ol/interaction";
import { MergedProjectResponse } from "../map-setup-context/InitialMapValues";
import {
  getDifferentiatedProjectCoordinatePoint,
  createMarkerStyle,
} from "./utils";

const getMarkerLayer = (
  projects: MergedProjectResponse[],
  selectedProject: MergedProjectResponse | null,
  setPopupInfo: (project: MergedProjectResponse) => void,
  setShowPopup: (showPopup: boolean) => void,
) => {
  const vectorSource = new VectorSource();
  const features = projects.map((project) => {
    const targetCenter = getDifferentiatedProjectCoordinatePoint(project);

    const iconFeature = new Feature({
      geometry: new Point(targetCenter),
      id: `marker-${project.id}`,
      project,
    });

    iconFeature.setStyle(
      createMarkerStyle(
        project,
        project.id === selectedProject?.id ? "selected" : "unselected",
      ),
    );

    return iconFeature;
  });

  vectorSource.addFeatures(features);

  const vectorLayer = new VectorLayer({
    source: vectorSource,
    className: "marker-layer",
  });

  vectorLayer.set("data-testid", "marker-layer");

  const selectClick = new Select({
    style: null,
  });

  selectClick.on("select", (event) => {
    const selectedFeature = event.selected[0];

    if (selectedFeature) {
      const project = selectedFeature.get("project") as MergedProjectResponse;

      setPopupInfo(project);
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  });

  return {
    vectorLayer,
    selectClick,
  };
};

export default getMarkerLayer;
